import { BaseStorage } from './base';
import { CurrentPlan } from '../../types/data';

const STORAGE_KEY = 'current_plans';

class CurrentPlanStorage extends BaseStorage<CurrentPlan> {
  constructor() {
    super(STORAGE_KEY);
  }
}

const storage = new CurrentPlanStorage();

export const getCurrentPlans = () => storage.get();
export const saveCurrentPlan = (plan: CurrentPlan) => {
  if (plan.id) {
    return storage.update(plan.id, plan);
  }
  return storage.create(plan);
};
export const deleteCurrentPlan = (id: string) => storage.delete(id);
export const clearCurrentPlans = () => storage.clear();
